import {Component, computed, input, output} from '@angular/core';
import {ElciaIcon} from '../../../../components/icon/icon';

@Component({
  selector: 'elcia-sub-todo-expander',
  imports: [ElciaIcon],
  templateUrl: './sub-todo-expander.html',
  styleUrl: './sub-todo-expander.scss',
})
export class SubTodoExpander {
  done = input.required<number>();
  total = input.required<number>();
  expanded = input.required<boolean>();
  onExpandClick = output<void>();

  state = computed<'inProgress' | 'done' | 'todo'>(() => {
    if (this.done() === this.total()) return 'done';
    if (this.done() === 0) return 'todo';
    return 'inProgress';
  })

  styleByState = computed(() => {
    switch (this.state()) {
      case 'done':
        return 'bg-emerald-500 text-white';
      case 'inProgress':
        return 'bg-orange-500 text-white';
      default:
        return 'bg-gray-500 text-white';
    }
  })

  protected handleClick(event: MouseEvent): void {
    event.stopPropagation();
    this.onExpandClick.emit();
  }
}
